import IconSvg from './IconSvg';
import './iconsvg.css';
export default IconSvg;
